import type { CSSProperties, ReactNode } from "react"
import classNames from "clsx"

type CalloutTone = "info" | "warning" | "success"

type CalloutProps = {
  tone?: CalloutTone
  children: ReactNode
  className?: string
  style?: CSSProperties
}

const toneStyles: Record<CalloutTone, { border: string; color: string; background: string }> = {
  info: {
    border: "rgba(255, 43, 79, 0.4)",
    color: "var(--text)",
    background: "rgba(255, 43, 79, 0.08)",
  },
  warning: {
    border: "rgba(255, 162, 43, 0.58)",
    color: "var(--warning-text)",
    background: "rgba(255, 162, 43, 0.12)",
  },
  success: {
    border: "rgba(70, 177, 120, 0.54)",
    color: "var(--success-text)",
    background: "rgba(70, 177, 120, 0.12)",
  },
}

export function Callout({ tone = "info", children, className, style }: CalloutProps) {
  const palette = toneStyles[tone]

  return (
    <div
      className={classNames("mono small", className)}
      role="status"
      style={{
        border: `1px solid ${palette.border}`,
        background: palette.background,
        color: palette.color,
        padding: "16px 18px",
        letterSpacing: "0.08em",
        textTransform: "none",
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default Callout
